import PrimaryButton from "../../CommonButtons/PrimaryButton";
import { useEffect, useRef, useState } from "react";

const CommonTermsAndConditionsPopup = ({
  setTermsConditionsPopupOpen,
  onDisagreeLogout,
  entityName,
  userName,
}) => {
  const scrollRef = useRef(null);
  const [btnEnable, setBtnEnable] = useState(false);
  const [animate, setAnimate] = useState(false);
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const onScroll = () => {
      const scrolledTo = el.scrollTop + el.clientHeight;
      const isReachBottom = Math.ceil(scrolledTo) >= el.scrollHeight;

      if (isReachBottom) {
        setBtnEnable(true);
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => {
      el.removeEventListener("scroll", onScroll);
    };
  }, []);
  return (
    <div
      className="flex w-full justify-center items-center m-auto top-top-half left-left-half fixed z-z-index-modal"
      style={{ transform: "translate(-50%, -50%)" }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={`max-h-reminder-popup-max-height w-small-popup-width Qmd:w-small-popup-width flex flex-col gap-y-gap-md  py-padding-md bg-primary-bg rounded-border-radius-md animate-none ${animate ? "Qmd:animate-slideInFromLeft" : "Qmd:animate-slideInFromRight"}`}
      >
        <div className=" flex flex-col gap-gap-xs px-padding-md">
          <p className={`text-text-primary text-font font-semibold`}>
            Terms and conditions
          </p>

          <p className="text-font-xs text-text-secondary font-normal ">
            By accessing or using the Xpentra system, you {userName} agree to
            the following Terms of Conditions.
          </p>
        </div>
        <div
          ref={scrollRef}
          className="flex flex-col flex-1 overflow-y-auto px-padding-md"
        >
          <div className="flex flex-col gap-gap-md">
            <div className="flex flex-col gap-gap-xs">
              <p className={`text-text-primary text-font-xs font-normal`}>
                You confirm that:
              </p>
              <div className="flex flex-col gap-gap-xs">
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  You are an authorized employee / representative of your
                  organization, {entityName}.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  Your access has been granted by your organization.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  Your use of the Xpentra Platform is on behalf of your
                  organization only.
                </p>
              </div>
            </div>
            <div className="flex flex-col gap-gap-xs">
              <p className={`text-text-primary text-font-xs font-normal`}>
                You acknowledge that:
              </p>
              <div className="flex flex-col gap-gap-xs">
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  Your organization has entered into a separate agreement with
                  Q2Pay Technologies Private Limited.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  Your use of the Xpentra system is governed by that agreement.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  You shall comply with all internal policies, approvals, and
                  authorization limits defined by your organization.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  Xpentra acts only as a technology platform provider.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  Xpentra does not initiate, approve, or control transactions.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  All transactions are executed based on your organization’s
                  instructions
                </p>
              </div>
            </div>
            <div className="flex flex-col gap-gap-xs">
              <p className={`text-text-primary text-font-xs font-normal`}>
                You agree that:
              </p>
              <div className="flex flex-col gap-gap-xs">
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  All actions performed using your login credentials are deemed
                  to be authorized by your organization.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  You will not exceed your assigned role, authority, or
                  transaction limits.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  You will ensure accuracy of transactions initiated or approved
                  by you.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  All actions performed by you on the Xpentra Platform shall be
                  binding on your organization.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  You will keep your login credentials confidential.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  You will not share access details with any other person.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  You will immediately report any unauthorized access.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  Your activity may be logged and monitored for security, audit,
                  and compliance purposes.
                </p>
              </div>
            </div>
            <div className="flex flex-col gap-gap-xs">
              <p className={`text-text-primary text-font-xs font-normal`}>
                You shall not:
              </p>
              <div className="flex flex-col gap-gap-xs">
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  Use the platform for any unlawful or fraudulent activity.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  Bypass approval workflows or internal controls.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  Introduce malicious code or attempt unauthorized access.
                </p>
              </div>
            </div>
            <div className="flex flex-col gap-gap-xs">
              <p className={`text-text-primary text-font-xs font-semibold`}>
                By clicking “I Agree”, you confirm that:
              </p>
              <div className="flex flex-col gap-gap-xs">
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  You have read and understood these Terms.
                </p>
                <p className="text-text-secondary text-font-xs font-normal list-item list-disc list-outside ml-margin-md">
                  You agree to comply with them.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full gap-gap-sm flex px-padding-md">
          <PrimaryButton
            btnText={"Disagree"}
            btnType={"button"}
            handleFunction={onDisagreeLogout}
            isDisabled={!btnEnable}
            enabledTextColor={"var(--text-primary)"}
            enabledBgColor={"transparent"}
            outLineColor={"var(--text-primary)"}
            hoverOption={"white"}
            isLoading={false}
            isLoaderNeeded={false}
            fullWidthRequired={true}
          />
          <PrimaryButton
            btnText={"Agree"}
            btnType={"button"}
            handleFunction={() => {
              setTermsConditionsPopupOpen(false);
            }}
            isDisabled={!btnEnable}
            enabledTextColor={"var(--text-primary)"}
            enabledBgColor={"var(--positive-act)"}
            disabledBgColor={"var(--text-disabled)"}
            hoverOption={"black"}
            isLoading={false}
            inActiveVariantNeeded={true}
            isLoaderNeeded={false}
            fullWidthRequired={true}
          />
        </div>
      </div>
    </div>
  );
};

export default CommonTermsAndConditionsPopup;
